import { useEffect, useState } from 'react'
import { useNavigate, useParams} from 'react-router-dom'
import { getDoc, updateDoc, doc} from 'firebase/firestore'
import {db} from '../../firebase'

//import moment from "moment";
//import 'moment/locale/es';

const Edit = () => {

  const [nomb, setNombr] = useState("");
  const [categoria, setCategoria] = useState('')
  const [subcategoria, setSubcategoria] = useState('')
  const [precio, setPrecio] = useState('0')
  const [stock, setStock] = useState('0')
  const [fecha, setFecha] = useState(Date.now())
  const [descripcion, setDescripcion] = useState('')
  const [altura, setAltura] = useState('0')
  const [anchura, setAnchura] = useState('0')
//const [imagen, setImagen] = useState(null)

  //En edit no estoy poniendo la IMAGEN, aunque puede parecer sencillo ya que seria lo mismo que en componente
  //create, pienso que me puede tomar mucho tiempo en hacer algo que no creo que pase mucho, asi que a la hora 
  // de registrar, verificar muy bien antes de elegir la foto y si es que se quiere editar la foto, se puede
  //hacer manualmente, pero si es que enevitablemente es algo que va a pasar a menudo tengo que trabajar en esta
  //parte, y guiarmee de Create.jsx para terminar de hacer esta parte.
  
  const navigate = useNavigate()
  const {id} = useParams()

  const update = async (e) => {
    e.preventDefault()
    const product = doc(db, "productos", id)
    const data = {
      nombre: nomb,
      categoria: categoria,
      subcategoria: subcategoria,
      descripcion: descripcion,
      precio: precio,
      altura: altura,
      anchura: anchura,
    //imagen: imagen,
      stock: stock, 
      fecha: fecha 
    }
    await updateDoc(product, data)
    navigate('/admin')
  }

  const getProductById = async (id) => {
      const product = await getDoc( doc(db, "productos", id))
      if(product.exists()) {
        setNombr(product.data().nombre)
        setCategoria(product.data().categoria)
        setSubcategoria(product.data().subcategoria)
        setPrecio(product.data().precio)
        setStock(product.data().stock)
        setAltura(product.data().altura)
        setAnchura(product.data().anchura)
        setDescripcion(product.data().descripcion)
 //setImagen(product.data().imagen)
      } else {
        console.log('El producto no existe.')
      }
  }

  useEffect(() => {
    getProductById(id)
  },[])

  return (
    <div className="container form">
            <div className="row">
                <div className="col">
                    <h1>Editar producto</h1>

                    <form onSubmit={update}>
                        <div className="mb-3">
                            <label className="form-label">Nombre</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={nomb}
                                onChange={(e) => setNombr(e.target.value)}    
                            />
                        </div>
                        <div className="mb-3">
                                <label className="form-label">Categoría</label>
                                <select className="form-control" id="categoria" name="categoria" onChange={(e) => setCategoria(e.target.value)} value={categoria} required>
                                    {/* <option>Elegir...</option> */}
                                    <option value="alabastro">Alabastro</option>
                                    <option value="cristal">Cristal</option>
                                    <option value="murano">Murano</option>
                                    <option value="poliresina">Poliresina</option>
                                    <option value="porcelana">Porcelana</option>
                                    <option value="manteleria">Manteleria/Cojines</option>
                                    <option value="flores">Flores artificiales</option>
                                    <option value="religion">Figuras religion</option>
                                    <option value="navidad">Navidad</option>
                                    <option value="general">General</option>
                                </select>
                            </div>

                            {
                                 categoria === 'navidad' ? (
                                <>
                                    <div className="mb-3">
                                        <label className="form-label">Categoría de Navidad🌲</label>
                                        <select className="form-control" id="subcategoria" name="subcategoria" onChange={(e) => setSubcategoria(e.target.value)} value={subcategoria} required>
                                            <option value="nacimientos">Nacimientos</option>
                                            <option value="adornosmusicales">Adorno musical</option>
                                            <option value="manteleria">Mantelería</option>
                                            <option value="cojines">Cojines</option>
                                            <option value="centroycoronas">Centro de mesa o coronas</option>
                                            <option value="farolesyvelas">Faroles y Velas</option>                                       
                                            <option value="adornosarbol">Adornos para árbol</option>
                                            <option value="acrilico">Acrilico</option>
                                            <option value="cascanueces">Cascanueces</option>
                                        </select>
                                    </div>
                                </>
                                ):(
                                    <div className="mb-3">
                                        <label className="form-label">Sub-Categoría</label>
                                        <select className="form-control" id="subcategoria" name="subcategoria" onChange={(e) => setSubcategoria(e.target.value)} value={subcategoria} required>
                                            <option>Elegir...</option>
                                            <option value="alabastro">Alabastro</option>
                                            <option value="cristal">Cristal</option>
                                            <option value="murano">Murano</option>
                                            <option value="poliresina">Poliresina</option>
                                            <option value="porcelana">Porcelana</option>
                                            <option value="manteleria">Manteleria/Cojines</option>
                                            <option value="flores">Flores artificiales</option>
                                            <option value="religion">Figuras religion</option>
                                            <option value="navidad">Navidad</option>
                                            <option value="general">General</option>
                                        </select>
                                    </div>
                                )
                               
                                
                            }

                        <div className="mb-3">
                            <label className="form-label">Precio</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={precio}
                                onChange={(e) => setPrecio(e.target.value)}    
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Stock</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={stock}
                                onChange={(e) => setStock(e.target.value)}    
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Alto</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={altura}
                                onChange={(e) => setAltura(e.target.value)}    
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Ancho</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={anchura}
                                onChange={(e) => setAnchura(e.target.value)}    
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Descripción</label>
                            <textarea 
                                 
                                className="form-control" 
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)}    
                            />
                        </div>

                        <button type='submit' className='btn btn-info'>Actualizar</button>
                    </form>
                </div>
            </div>
        </div>
  )
}

export default Edit
